import React from 'react';
import { Check } from 'lucide-react';
import { STEPS } from '../constants';

export default function StepIndicator({ currentStep }) {
    const currentIdx = STEPS.findIndex(s => s.id === currentStep);
    const isLastStep = currentIdx === STEPS.length - 1;

    return (
        <div className="flex items-center justify-between mb-8">
            {STEPS.map((step, idx) => {
                // On the final step, every step (including the last) reads as complete —
                // landing on Result means you've finished the chain. Otherwise, only
                // steps strictly before the current one are complete; the current is
                // highlighted blue.
                const isComplete = isLastStep ? idx <= currentIdx : idx < currentIdx;
                const isCurrent = !isLastStep && idx === currentIdx;
                return (
                    <React.Fragment key={step.id}>
                        <div className="flex flex-col items-center flex-shrink-0">
                            <div className={`w-9 h-9 rounded-full flex items-center justify-center font-semibold text-sm
                                ${isComplete ? 'bg-green-500 text-white' : ''}
                                ${isCurrent  ? 'bg-blue-600 text-white ring-4 ring-blue-100 dark:ring-blue-950' : ''}
                                ${!isComplete && !isCurrent ? 'bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-400' : ''}`}>
                                {isComplete ? <Check size={16} /> : idx + 1}
                            </div>
                            <div className="mt-2 text-xs font-medium text-slate-800 dark:text-slate-100">{step.label}</div>
                            <div className="text-[10px] text-slate-500 dark:text-slate-400">{step.detail}</div>
                        </div>
                        {idx < STEPS.length - 1 && (
                            <div className={`flex-1 h-0.5 mx-2 mt-4 ${idx < currentIdx ? 'bg-green-500' : 'bg-slate-200 dark:bg-slate-700'}`} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
